"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CommonErrorMessage = void 0;

var _index = _interopRequireDefault(require("./components/index"));

exports.CommonErrorMessage = _index["default"];